import React, { useState, useEffect } from 'react';
import { useQueryClient, useQuery } from '@tanstack/react-query';
import { updateMember } from '../../api/members';
import api from '../../api/client';
import Modal from '../ui/Modal';
import FormField, { Input, Select, FormRow, SubmitBtn } from '../ui/FormField';
import toast from 'react-hot-toast';

export default function EditMemberModal({ open, onClose, member }: { open: boolean; onClose: () => void; member: any }) {
  const qc = useQueryClient();
  const [form, setForm] = useState<any>({});
  const [loading, setLoading] = useState(false);

  const { data: types } = useQuery({
    queryKey: ['member-types'],
    queryFn: () => api.get('/members/types'),
    enabled: open
  } as any);

  const [initialized, setInitialized] = React.useState(false);

  useEffect(() => {
    if (member && !initialized) { setInitialized(true); setForm({
      first_name: member.first_name || '',
      last_name: member.last_name || '',
      email: member.email || '',
      phone: member.phone || member.home_phone || '',
      address: member.address || '',
      id_number: member.id_number || '',
      member_type_id: member.member_type_id || '',
      is_active: member.is_active ?? 1,
    }); }
  }, [member, initialized]);

  useEffect(() => { if (!open) setInitialized(false); }, [open]);

  const set = (k: string) => (e: any) => setForm((f: any) => ({...f, [k]: e.target.value}));

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!form.first_name || !form.last_name) return toast.error('სახელი და გვარი სავალდებულოა');
    setLoading(true);
    try {
      await updateMember(member.id, form);
      toast.success('წევრი განახლდა!');
      qc.invalidateQueries({ queryKey: ['member', String(member.id)] });
      qc.invalidateQueries({ queryKey: ['members'] });
      onClose();
    } catch { toast.error('შეცდომა'); }
    finally { setLoading(false); }
  };

  return (
    <Modal open={open} onClose={onClose} title="წევრის რედაქტირება" width={500}>
      <form onSubmit={handleSubmit}>
        <FormRow>
          <FormField label="სახელი" required>
            <Input value={form.first_name||''} onChange={set('first_name')} placeholder="სახელი" />
          </FormField>
          <FormField label="გვარი" required>
            <Input value={form.last_name||''} onChange={set('last_name')} placeholder="გვარი" />
          </FormField>
        </FormRow>
        <FormField label="ელ-ფოსტა">
          <Input type="email" value={form.email||''} onChange={set('email')} placeholder="mail@example.com" />
        </FormField>
        <FormRow>
          <FormField label="ტელეფონი">
            <Input value={form.phone||''} onChange={set('phone')} placeholder="+995 5xx xxx xxx" />
          </FormField>
          <FormField label="პირადი №">
            <Input value={form.id_number||''} onChange={set('id_number')} placeholder="01234567890" />
          </FormField>
        </FormRow>
        <FormField label="მისამართი">
          <Input value={form.address||''} onChange={set('address')} placeholder="მისამართი" />
        </FormField>
        <FormRow>
          <FormField label="ტიპი">
            <Select value={form.member_type_id||''} onChange={set('member_type_id')}>
              <option value="">— ტიპი —</option>
              {((types as any)?.data?.types||[]).map((t: any) => (
                <option key={t.id} value={t.id}>{t.name}</option>
              ))}
            </Select>
          </FormField>
          <FormField label="სტატუსი">
            <Select value={String(form.is_active)} onChange={e => setForm((f: any) => ({...f, is_active: parseInt(e.target.value)}))}>
              <option value="1">აქტიური</option>
              <option value="0">გათიშული</option>
            </Select>
          </FormField>
        </FormRow>
        <SubmitBtn loading={loading} label="შენახვა" />
      </form>
    </Modal>
  );
}
